import { ConfigProvider } from "antd";
import { ReactNode } from "react";
import { ThemeConfig } from "antd";

type ThemeProviderProps = {
  children: ReactNode;
  theme: ThemeConfig;
};

const ThemeProvider: React.FC<ThemeProviderProps> = ({ children, theme }) => {
  return <ConfigProvider theme={theme}>{children}</ConfigProvider>;
};

export default ThemeProvider;
